import { useState } from 'react';
import { Alerta, Botao, Cartao, Titulo } from './ui';

export function Consentimento({ aoAceitar }: { aoAceitar: () => Promise<void> }) {
  const [marcado, setMarcado] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  return (
    <Cartao>
      <Titulo sub="Antes de enviar qualquer documento, precisamos do seu ok.">
        Uso dos seus dados
      </Titulo>
      <div className="space-y-3 text-sm leading-relaxed text-slate-700">
        <p>
          Os documentos e dados enviados aqui (identidade, CPF, comprovante de residência, certidão
          de casamento, IPTU) são usados
          <strong> somente para registrar a sua empresa</strong>: consulta de viabilidade, registro
          na Junta Comercial, CNPJ, inscrições estadual e municipal e licenças.
        </p>
        <p>
          Eles ficam guardados de forma criptografada, com acesso registrado, e os arquivos são{' '}
          <strong>apagados 12 meses após a conclusão</strong> da abertura. A ficha da empresa e os
          protocolos ficam no seu histórico.
        </p>
        <p>
          A leitura inicial dos documentos é feita por um sistema automático, sempre conferida por
          uma pessoa da nossa equipe. Base legal: execução de contrato e cumprimento de obrigação
          legal (registro empresarial), conforme a LGPD.
        </p>
      </div>
      <label className="mt-4 flex items-start gap-3 rounded-xl border border-slate-200 p-3">
        <input
          type="checkbox"
          checked={marcado}
          onChange={(e) => setMarcado(e.target.checked)}
          className="mt-0.5"
        />
        <span className="text-sm">
          Li e concordo com o uso dos meus dados e dos dados dos sócios para a abertura da empresa.
        </span>
      </label>
      {erro && (
        <div className="mt-3">
          <Alerta tipo="erro">{erro}</Alerta>
        </div>
      )}
      <Botao
        className="mt-4 w-full"
        disabled={!marcado}
        carregando={enviando}
        onClick={async () => {
          setEnviando(true);
          setErro(null);
          try {
            await aoAceitar();
          } catch (e) {
            setErro((e as Error).message);
          } finally {
            setEnviando(false);
          }
        }}
      >
        Concordo e quero começar
      </Botao>
    </Cartao>
  );
}
